import { t } from 'i18next'

import { formatResponsePatchCampaign } from '~/modules/retailMedia/dtos/common/campaign/patch'

import { types } from '../constants'

type PatchValues = {
  patchKey?: string
}

const index = {
  pending: `${types.patch}_PENDING`,
  fulfilled: `${types.patch}_FULFILLED`,
  rejected: `${types.patch}_REJECTED`
}

const isCampaignPatchResponse = (
  payload: unknown
): payload is PatchResponse => {
  if (!payload || typeof payload !== 'object') return false

  const data = payload as Record<string, unknown>

  return (
    typeof data.name === 'string' ||
    typeof data.status === 'string' ||
    !!data.settings
  )
}

export const patch = {
  [index.pending]: ({ draft, action }: ActionData<unknown, PatchValues>) => {
    const patchKey = action.values?.patchKey || 'default'

    const oldLoading = draft.industry.campaign.patch.loadingKeys

    draft.industry.campaign.patch.loading = true
    draft.industry.campaign.patch.loadingKeys = [...oldLoading, patchKey]
    draft.industry.campaign.patch.error = null
  },
  [index.fulfilled]: ({
    draft,
    action
  }: ActionData<PatchResponse, PatchValues>) => {
    const patchKey = action.values?.patchKey || 'default'

    const oldLoading = draft.industry.campaign.patch.loadingKeys

    draft.industry.campaign.patch.loading = false
    draft.industry.campaign.patch.loadingKeys = oldLoading.filter(
      item => item !== patchKey
    )
    draft.industry.campaign.patch.error = null

    // Only merge into the open campaign when the payload looks like a
    // campaign patch. Endpoints like network destination-urls reuse
    // `types.patch` but return `{ network_id, campaign_id, destination_urls }`
    // — merging that would wipe `settings.require_subpublisher_approval`
    // (and name/status/etc.) and collapse the grouped DestinationUrls UI
    // into the empty legacy state.
    if (isCampaignPatchResponse(action.payload) && draft.campaign.item.data) {
      draft.campaign.item.data = formatResponsePatchCampaign({
        currentData: draft.campaign.item.data,
        updatedData: action.payload
      })
    }
  },
  [index.rejected]: ({ draft, action }: ActionData<unknown, PatchValues>) => {
    const patchKey = action.values?.patchKey || 'default'

    const oldLoading = draft.industry.campaign.patch.loadingKeys

    draft.industry.campaign.patch.loading = false
    draft.industry.campaign.patch.loadingKeys = oldLoading.filter(
      item => item !== patchKey
    )

    draft.industry.campaign.patch.error =
      !!action.payload && t('rm:actions.industry.campaign.patch.campaignError')
  }
}
